// FILE: client/src/reducers/portfolioReducers.js
import {
  PORTFOLIO_LIST_REQUEST,
  PORTFOLIO_LIST_SUCCESS,
  PORTFOLIO_LIST_FAIL,
  PORTFOLIO_ADMIN_LIST_REQUEST,
  PORTFOLIO_ADMIN_LIST_SUCCESS,
  PORTFOLIO_ADMIN_LIST_FAIL,
  PORTFOLIO_DETAILS_REQUEST,
  PORTFOLIO_DETAILS_SUCCESS,
  PORTFOLIO_DETAILS_FAIL,
  PORTFOLIO_CREATE_REQUEST,
  PORTFOLIO_CREATE_SUCCESS,
  PORTFOLIO_CREATE_FAIL,
  PORTFOLIO_CREATE_RESET,
  PORTFOLIO_UPDATE_REQUEST,
  PORTFOLIO_UPDATE_SUCCESS,
  PORTFOLIO_UPDATE_FAIL,
  PORTFOLIO_UPDATE_RESET,
  PORTFOLIO_DELETE_REQUEST,
  PORTFOLIO_DELETE_SUCCESS,
  PORTFOLIO_DELETE_FAIL,
  PORTFOLIO_DELETE_RESET,
} from "../constants/portfolioConstants";

export const portfolioListReducer = (state = { items: [] }, action) => {
  switch (action.type) {
    case PORTFOLIO_LIST_REQUEST:
      return { loading: true, items: [] };
    case PORTFOLIO_LIST_SUCCESS:
      return { loading: false, items: action.payload || [] };
    case PORTFOLIO_LIST_FAIL:
      return { loading: false, error: action.payload, items: [] };
    default:
      return state;
  }
};

export const portfolioAdminListReducer = (state = { items: [] }, action) => {
  switch (action.type) {
    case PORTFOLIO_ADMIN_LIST_REQUEST:
      return { loading: true, items: [] };
    case PORTFOLIO_ADMIN_LIST_SUCCESS:
      return { loading: false, items: action.payload || [] };
    case PORTFOLIO_ADMIN_LIST_FAIL:
      return { loading: false, error: action.payload, items: [] };
    default:
      return state;
  }
};

export const portfolioDetailsReducer = (state = { item: null }, action) => {
  switch (action.type) {
    case PORTFOLIO_DETAILS_REQUEST:
      return { loading: true, item: null };
    case PORTFOLIO_DETAILS_SUCCESS:
      return { loading: false, item: action.payload };
    case PORTFOLIO_DETAILS_FAIL:
      return { loading: false, error: action.payload, item: null };
    default:
      return state;
  }
};

export const portfolioCreateReducer = (state = {}, action) => {
  switch (action.type) {
    case PORTFOLIO_CREATE_REQUEST:
      return { loading: true };
    case PORTFOLIO_CREATE_SUCCESS:
      return { loading: false, success: true, item: action.payload };
    case PORTFOLIO_CREATE_FAIL:
      return { loading: false, error: action.payload };
    case PORTFOLIO_CREATE_RESET:
      return {};
    default:
      return state;
  }
};

export const portfolioUpdateReducer = (state = {}, action) => {
  switch (action.type) {
    case PORTFOLIO_UPDATE_REQUEST:
      return { loading: true };
    case PORTFOLIO_UPDATE_SUCCESS:
      return { loading: false, success: true, item: action.payload };
    case PORTFOLIO_UPDATE_FAIL:
      return { loading: false, error: action.payload };
    case PORTFOLIO_UPDATE_RESET:
      return {};
    default:
      return state;
  }
};

export const portfolioDeleteReducer = (state = {}, action) => {
  switch (action.type) {
    case PORTFOLIO_DELETE_REQUEST:
      return { loading: true };
    case PORTFOLIO_DELETE_SUCCESS:
      return { loading: false, success: true };
    case PORTFOLIO_DELETE_FAIL:
      return { loading: false, error: action.payload };
    case PORTFOLIO_DELETE_RESET:
      return {};
    default:
      return state;
  }
};
